<template>
  <div class="practiceKQItem">
    <Header title="考勤学生明细" type="0" route="/practiceKQ/index"></Header>
    <div class="research">
      <van-field input-align="right" readonly required>
        <template #input>
          <span @click="showPOP">{{ value.mc }}</span>
        </template>
        <template #label>
          <span class="label-class" @click="onShow('请选择查询条件', 'tj')">
            {{ tj.mc }}
            <van-icon name="arrow" />
          </span>
        </template>
      </van-field>
      <el-table :data="tableData" ref="tableDataRef" border style="width: 100%">
        <el-table-column prop="xh" label="学号" min-width="35%" align="center">
        </el-table-column>
        <el-table-column prop="xm" label="姓名" min-width="20%" align="center">
        </el-table-column>
        <el-table-column
          min-width="30%"
          :label="tj.dm == 1 ? '日期' : tj.dm == 2 ? '周次' : '月份'"
          align="center"
          prop="sxkqrq"
        >
        </el-table-column>
        <el-table-column label="考勤次数" min-width="15%" align="center">
          <template slot-scope="scope">
            <el-button @click="goDetail(scope.row)" type="text" size="small">{{
              scope.row.kqcs
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <van-popup v-model="showDay" position="bottom"
      ><van-datetime-picker
        v-model="value.mc"
        :type="type.text"
        :title="type.mc"
        :formatter="formatter"
        @change="
          (value, index) => {
            change(type.dm);
          }
        "
        @confirm="
          (value, index) => {
            onConfirm(value, index, type.dm);
          }
        "
        @cancel="showDay = false"
    /></van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      type: {
        text: "date",
        dm: "day",
        mc: "请选择年月日"
      },
      showDay: false,
      show: false,
      tj: {
        mc: "按天",
        dm: "1"
      },
      value: {
        mc: "请选择具体日期",
        dm: ""
      },
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      tableData: []
    };
  },
  created() {
    this.setResearch();
    this.$route.query.list = JSON.parse(this.$route.query.list);
  },
  methods: {
    async getList() {
      const res = await Api.getsxkqxslist({
        id: this.$route.query.list.id,
        cxlx: this.tj.dm,
        cxnr: this.value.dm
      });
      this.tableData = res.data;
    },
    change(mc) {
      var value1 = new Date();

      if (mc == "day") {
        this.value.mc =
          value1.getFullYear() +
          "年" +
          (value1.getMonth() + 1 < 10
            ? "0" + (value1.getMonth() + 1)
            : value1.getMonth() + 1) +
          "月" +
          (value1.getDate() < 10 ? "0" + value1.getDate() : value1.getDate()) +
          "日";
      } else {
        this.value.mc =
          value1.getFullYear() +
          "年" +
          (value1.getMonth() + 1 < 10
            ? "0" + (value1.getMonth() + 1)
            : value1.getMonth() + 1) +
          "月";
      }
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    showPOP() {
      if (this.tj.mc == "按天") {
        this.showDay = true;
      } else if (this.tj.mc == "按周") {
        this.onShow("请选择周次", "value");
      } else if (this.tj.mc == "按月") {
        this.showDay = true;
      }
    },
    goDetail(item) {
      item.id = this.$route.query.list.id;
      item.cxlx = this.tj.dm;
      item.cxnr = this.value.dm;
      item.route = "/practiceKQ/item";
      this.$router.push({
        path: "/sxKq/item",
        query: {
          list: item
        }
      });
    },
    onConfirm(value, index, value1) {
      this.value = {
        mc: "请选择具体日期",
        dm: ""
      };
      if (value1 == "day") {
        this.showDay = false;
        this.value.mc =
          value.getFullYear() +
          "年" +
          (value.getMonth() + 1 < 10
            ? "0" + (value.getMonth() + 1)
            : value.getMonth() + 1) +
          "月" +
          (value.getDate() < 10 ? "0" + value.getDate() : value.getDate()) +
          "日";
        this.value.dm =
          value.getFullYear() +
          "-" +
          (value.getMonth() + 1 < 10
            ? "0" + (value.getMonth() + 1)
            : value.getMonth() + 1) +
          "-" +
          (value.getDate() < 10 ? "0" + value.getDate() : value.getDate());
        console.log(this.value);
        this.getList();
        return;
      }
      if (value1 == "month") {
        this.showDay = false;
        this.value.mc =
          value.getFullYear() +
          "年" +
          (value.getMonth() + 1 < 10
            ? "0" + (value.getMonth() + 1)
            : value.getMonth() + 1) +
          "月";
        this.value.dm =
          value.getFullYear() +
          "-" +
          (value.getMonth() + 1 < 10
            ? "0" + (value.getMonth() + 1)
            : value.getMonth() + 1);
        console.log(this.value);
        this.getList();

        return;
      }
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;

      if (value1 == "tj") {
        this.value.mc =
          "请选择具体" +
          (value.value == 1 ? "日期" : value.value == 2 ? "周次" : "月份");
        if (value.value == "3") {
          this.type = "year-month";

          this.type = {
            text: "year-month",
            dm: "month",
            mc: "请选择年月"
          };
        }
        if (value.value == "1") {
          this.type = {
            text: "date",
            dm: "day",
            mc: "请选择年月日"
          };
        }
        this.$nextTick(() => {
          this.$refs.tableDataRef.doLayout();
        });
        return;
      }

      this.getList();
    },
    // 弹出选择器
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    setResearch() {
      this.columns.tj = [
        {
          text: "按天",
          // value: "日期",
          value: "1"
        },
        {
          text: "按周",
          // value: "周次",
          value: "2"
        },
        {
          text: "按月",
          // value: "月份",
          value: "3"
        }
      ];
      this.columns.value = [];
      for (var num = 1; num <= 25; num++) {
        this.columns.value.push({
          text: "第" + num + "周",
          value: num
        });
      }
    }
  }
};
</script>
<style lang="less">
.practiceKQItem .research {
  padding: 0 20px;
  .label-class {
    display: flex;
    align-items: center;
    i {
      color: #969799;
    }
  }
}
</style>
<style lang="less">
.practiceKQItem {
  .research {
    .van-cell {
      border-bottom: 1px solid #f4f4f4;
      margin-bottom: 10px;
    }
    .van-cell::after {
      display: none;
    }
    .van-field__label {
      width: 7.2em;
      span {
        width: 96px !important;
        display: inline-block;
      }
    }
    .van-cell.van-field .van-cell__title.van-field__label > span {
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      font-weight: normal;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      font-weight: normal;
      text-align: right;
    }
    .van-field__control {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
      text-align: right;
      font-weight: bolder;
    }
    .van-icon-arrow {
      color: #dfe0e6;
      font-weight: bolder;
      font-size: 14px;
    }
    .van-cell__title,
    .van-cell.van-field .van-cell__title.van-field__label > span {
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Light;
      font-size: 16px;
      color: #212f6e;
      letter-spacing: 0;
    }
    .van-field__control::-webkit-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-moz-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
    .van-field__control::-ms-input-placeholder {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #dfe0e6 !important;
      letter-spacing: 0;
      text-align: right;
    }
  }
  .el-table td {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/practiceKQ/item.vue